<template>
  <div
    :class="
      cn(
        'absolute left-0 right-0 h-[80%] lg:h-[60%] bottom-0 bg-linear-to-r from-primary/80 via-magenta/80 to-primary/80 flex flex-row',
        props.class
      )
    "
  >
    <div class="absolute inset-0 bg-linear-to-b from-background"></div>
  </div>
  <div class="absolute inset-0 bg-linear-to-b from-background"></div>
  <div class="noise absolute inset-0"></div>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

export interface GridProps {
  class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<GridProps>(), {
  class: undefined
})
</script>

<style scoped>
.noise {
  pointer-events: none;
  opacity: 0.4;
  mix-blend-mode: overlay;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='180' viewBox='0 0 180 180'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.55' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='180' height='180' filter='url(%23n)' opacity='0.8'/%3E%3C/svg%3E");
  background-size: 190px 190px;
  filter: contrast(165%) brightness(118%);
}
</style>
